import '../style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { Caption } from 'views/mutual/caption';
import { UnitInput, UnitInputPosition } from 'views/templates/module/unitInput';
import { InputTemplate, MaskType } from 'views/templates/module/inputTemplate';
import { AddressInput } from 'views/templates/module/addressInput';
import { useDealerInfo } from './hooks';
import { FormContentHeader, FormType } from 'views/templates/module/contentHeader';
import { TemplateProps } from '../common';
import { DateInput } from 'views/mutual/dateInput';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { useCustomLocationName } from 'views/mutual/location/hooks';

export type DealerInfoProps = {
  formik: any;
  dealerFirstNameProps: any;
  dealerLastNameProps: any;
  dealerFirstNameKanaProps: any;
  dealerLastNameKanaProps: any;
  dealerBirthDayProps: any;
  dealerAddressPorps: any;
  dealerMobilePhoneNumberProps: any;
  dealerMailAddressPorps: any;
  dealerConfirmMailAddressPorps: any;
  dealerDepartmentProps: any;
  dealerOtherDepartmentProps: any;
  dealerPositionProps: any;
  goBackProps: any;
};

export const DealerInfoWrapper = () => {
  return <DealerInfo {...useDealerInfo({ isUpdate: false })} />;
};

export const DealerInfo = ({
  formik,
  dealerFirstNameProps,
  dealerLastNameProps,
  dealerFirstNameKanaProps,
  dealerLastNameKanaProps,
  dealerBirthDayProps,
  dealerAddressPorps,
  dealerMobilePhoneNumberProps,
  dealerMailAddressPorps,
  dealerConfirmMailAddressPorps,
  dealerDepartmentProps,
  dealerOtherDepartmentProps,
  dealerPositionProps,
  goBackProps,
  isUpdate,
}: DealerInfoProps & TemplateProps) => {
  useCustomLocationName('口座開設申込みフォーム');

  return (
    <form onSubmit={formik.handleSubmit} className="accountOpenTemplate">
      {!isUpdate && (
        <div className="accountOpenTemplate_description">
          <Caption label="取引担当者情報" />
          <Description
            label={`代表者様を取引担当者様とする場合は、代表者様の情報をご入力ください。`}
            labelColor={labelColor.black}
            labelSize={labelSize.small}
          />
        </div>
      )}

      <div className="accountOpenTemplate_input">
        <FormContentHeader label="取引担当者氏名" formType={FormType.Required} />
        <div className="accountOpenTemplate_input_wrapper">
          <UnitInput label="姓" unit={UnitInputPosition.before} placeholder="例：東京" {...dealerLastNameProps} />
          <UnitInput label="名" unit={UnitInputPosition.before} placeholder="例：太郎" {...dealerFirstNameProps} />
        </div>
        <FormContentHeader label="取引担当者氏名（フリガナ）" formType={FormType.Required} />
        <div className="accountOpenTemplate_input_wrapper">
          <UnitInput
            label="セイ"
            unit={UnitInputPosition.before}
            placeholder="例：トウキョウ"
            {...dealerLastNameKanaProps}
          />
          <UnitInput label="メイ" unit={UnitInputPosition.before} placeholder="例：タロウ" {...dealerFirstNameKanaProps} />
        </div>
        <FormContentHeader label="生年月日" formType={FormType.Required} />
        <div className="accountOpenTemplate_input_wrapper">
          <DateInput placeholder={'年/月/日'} showYearMonthDropdown={true} {...dealerBirthDayProps} />
        </div>
        <FormContentHeader label="取引担当者住所" formType={FormType.Required} />
        <div className="accountOpenTemplate_explanation">
        本人確認書類に記載の住所と同一の住所をご入力ください。
        </div>
        <div className="accountOpenTemplate_input_wrapper">
          <AddressInput name="dealer_address" {...dealerAddressPorps} />
        </div>
        <FormContentHeader label="取引担当者携帯電話番号" formType={FormType.Required} />
        <div className="accountOpenTemplate_explanation">
          <a
            className="accountOpenTemplate_input_wrapper_link"
            href={process.env.REACT_APP_ELECTORIC_GENERAL_TERMS_CONDITION_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            FPGオンライン取引・電子署名取引一般規約
          </a>
          に定める本件電子署名サービスに使用する電話番号（指定電話番号）として届け出ます。
        </div>
        <div className="accountOpenTemplate_input_wrapper">
          <InputTemplate
            type="tel"
            placeholder="例：08000000000（ハイフンは不要です）"
            maxLength={11}
            masked={isUpdate ? { type: MaskType.Start, displayedCount: 4 } : undefined}
            {...dealerMobilePhoneNumberProps}
          />
        </div>
        <FormContentHeader label="メールアドレス" formType={FormType.Required} />
        <div className="accountOpenTemplate_explanation">
          <a
            className="accountOpenTemplate_input_wrapper_link"
            href={process.env.REACT_APP_ELECTORIC_GENERAL_TERMS_CONDITION_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            FPGオンライン取引・電子署名取引一般規約
          </a>
          に定める本件電子署名サービスに使用するメールアドレス（指定アドレス）として届け出ます。
        </div>
        <div className="accountOpenTemplate_input_wrapper">
          <InputTemplate
            type="text"
            placeholder="例：example@example.com"
            masked={isUpdate ? { type: MaskType.End, displayedCount: 4 } : undefined}
            {...dealerMailAddressPorps}
          />
        </div>
        {isUpdate ? (
          <>
            <FormContentHeader label="メールアドレス（確認用）" formType={FormType.Required} />
            <div className="accountOpenTemplate_input_wrapper">
              <InputTemplate
                type="text"
                placeholder="例：example@example.com"
                masked={isUpdate ? { type: MaskType.End, displayedCount: 4 } : undefined}
                {...dealerConfirmMailAddressPorps}
              />
            </div>
          </>
          ) : (
            <></>
          )}
        <FormContentHeader label="所属部署" formType={FormType.Required} />
        <div className="accountOpenTemplate_input_wrapper">
          <InputTemplate
            type="text"
            placeholder="例：総務部（代表者様の場合は「無し」と入力ください）"
            {...dealerDepartmentProps}
          />
        </div>
        <FormContentHeader label="その他所属部署" formType={FormType.Optional} />
        <div className="accountOpenTemplate_input_wrapper">
          <InputTemplate
            type="text"
            placeholder="所属部署が複数ある場合は、ご記入ください"
            {...dealerOtherDepartmentProps}
          />
        </div>
        <FormContentHeader label="ご役職" formType={FormType.Required} />
        <div className="accountOpenTemplate_input_wrapper">
          <InputTemplate type="text" placeholder="例：代表取締役社長" {...dealerPositionProps} />
        </div>
      </div>
      {!isUpdate && (
        <div className="accountOpenTemplate_button">
          <Button type={ButtonType.Submit} label="次へ" buttonFill={ButtonFill.black} buttonSize={ButtonSize.medium} />
          <Button label="前の画面に戻る" buttonFill={ButtonFill.link} buttonSize={ButtonSize.small} {...goBackProps} />
        </div>
      )}
    </form>
  );
};
